import React from 'react';
import './summary-boxes.css';

const SummaryBoxes = (props) => {
  const {
    authorableContent: {
      estimatedCostTIPTText,
      estimatedCostLiberateText,
      perMonthText,
      totalMonthlyCostText,
    },
    tiptCost,
    liberateCost,
  } = props;

  return (
    <div className="summary-boxes-section">
      <div className="row">
        <div className="col-md-6 outer-estimated-box left">
          <div className="estimated-box">
            <div className="row">
              <div className="col-12 heading heading24">
                {estimatedCostTIPTText}
              </div>
              <div className="col-12 sub-heading heading16">
                {totalMonthlyCostText}
              </div>
              <div className="col-12 body25 cost">
                <sub>$</sub>
                {tiptCost}
                <sub>{perMonthText}</sub>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 outer-estimated-box right">
          <div className="estimated-box">
            <div className="row">
              <div className="col-12 heading heading24">
                {estimatedCostLiberateText}
              </div>
              <div className="col-12 sub-heading heading16">
                {totalMonthlyCostText}
              </div>
              <div className="col-12 body25 cost">
                <sub>$</sub>
                {liberateCost}
                <sub>{perMonthText}</sub>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryBoxes;
